module.exports = __webpack_public_path__ + "img/color-14.466c68a.png";